<template>
  <div id="myDiv">
    <header class="blog-header py-3">
            <div class="row flex-nowrap justify-content-between align-items-center">
              <div class="col-2 pt-1">
                <a href="/"><img src="./assets/images/NewLogoTurkeyMini.png" /></a>
              </div>
              <div class="col-7 text-center">
                <a class="blog-header-logo text-dark text-center">{{title}}</a>
              </div>
              <div class="row col-4 align-items-center">
                  <div class="row" style="padding-bottom:14px;">
                    <p>
                    <Countdown
                      starttime="Nov 5, 2018 15:37:25" 
                      endtime="Nov 28, 2019 12:00:00" 
                      trans='{  
                      "day":"Days",
                      "hours":"Hours",
                      "minutes":"Minutes",
                      "seconds":"Seconds",
                      "expired":"Event has been expired.",
                      "running":"Till the end of event.",
                      "upcoming":"Till start of event.",
                      "status": {
                      "expired":"Expired",
                      "running":"Running",
                      "upcoming":"Future"
                      }}'>
                    </Countdown>
                    </p>
                  </div>
              </div>
            </div>
        </header>
    <Navbar />
    <router-view />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Countdown from './components/Countdown'
export default {
  name: 'app',
  data () {
    return {
      title: "The Turkey Bowl Classic"
    }
  },
  components: {
    Navbar,
    Countdown
  }
}
</script>

<style>
.blog-header {
    line-height: 1;
    border-bottom: 1px solid #e5e5e5;
  }
.bg-color {
    background-color: #EFE2BA;
}
.blog-header-logo {
    font-family: "Rubik", Georgia, "Times New Roman", serif;
    font-size: 3.00rem;
}
h1, h2, h3, h4, h5, h6 {
  font-family: "Playfair Display", Georgia, "Times New Roman", serif;
}
.display-4 {
  font-size: 2.5rem;
}
@media (min-width: 768px) {
  .display-4 {
    font-size: 3rem;
  }
}  
.nav-scroller {
  position: relative;
  z-index: 2;
  height: 2.75rem;
  overflow-y: hidden;
} 
.nav-scroller .nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  padding-bottom: 1rem;
  margin-top: -1px;
  overflow-x: auto;
  text-align: center;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  background-color: #f13c20;
}  
.nav-scroller .nav-link {
  padding-top: .75rem;
  padding-bottom: .75rem;
  font-size: .875rem;
}
.card-img-right {
  height: 100%;
  border-radius: 0 3px 3px 0;
}
.flex-auto {
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}
.h-250 { height: 250px; }
@media (min-width: 768px) {
  .h-md-250 { height: 250px; }
}
.blog-title {
  margin-bottom: 0;
  font-size: 2rem;
  font-weight: 400;
}
.blog-description {
  font-size: 1.1rem;
  color: #999;
}
  
@media (min-width: 40em) {
  .blog-title {
    font-size: 3.5rem;
  }
}
  .blog-pagination {
    margin-bottom: 4rem;
  }
  .blog-pagination > .btn {
    border-radius: 2rem;
  }
.blog-post {
  margin-bottom: 4rem;
}
.blog-post-title {
  margin-bottom: .25rem;
  font-size: 2.5rem;
}
.blog-post-meta {
  margin-bottom: 1.25rem;
  color: #999;
}
.blog-footer {
  padding: 2.5rem 0;
  color: #999;
  text-align: center;
  background-color: #f9f9f9;
  border-top: .05rem solid #e5e5e5;
}
.blog-footer p:last-child {
  margin-bottom: 0;
}
#players {
  margin: 0px auto;
}
#players td{
  vertical-align: middle;
}
#app {
  padding: 1rem 2rem 2rem 2rem
}
</style>



// WEBPACK FOOTER //
// src/App.vue